import { ActionResult, DirectoryItem } from '../types'
import { useDirectoryTree } from '../useDirectoryTree'
import { ExecutableAction } from './action'

export class ArchiveAction extends ExecutableAction {
  static readonly actionName = 'archive'
  public readonly actionName = ArchiveAction.actionName

  constructor(private readonly items: DirectoryItem[], private readonly state: boolean) {
    super()
  }

  override async execute(tree: ReturnType<typeof useDirectoryTree>): Promise<ActionResult> {
    this.items.forEach((item) => {
      tree.updateNodeDetails(item.id, { archived: this.state })
    })

    return { status: 'success', data: undefined }
  }

  override async undo(tree): Promise<ActionResult> {
    return new ArchiveAction(this.items, !this.state).execute(tree)
  }
}
